import { PXRESEVERPROP, ARRAYPXRESEVERPROP } from "utils/index"

export function buildModel(model, baseWidth) {
  for (let i in model) {
    if (model[i] != null) {
      try {
        if (typeof model[i] == "object") {
          if (i === "chartOption") {
            continue
          } else if (ARRAYPXRESEVERPROP.indexOf(i) > -1) {
            if (Array.isArray(model[i])) {
              model[i] = model[i].map(item => handdleNumberPointFix(item, baseWidth))
            }
          } else if (i === "event") {
            fixEvents(model[i], baseWidth)
            continue
          } else {
            buildModel(model[i], baseWidth)
          }
        } else if (i === "layoutUidMap") {
          delete model[i]
        } else {
          if (i === "swiperMode" && model[i]) {
            model[i] = false
          }
          if (PXRESEVERPROP.indexOf(i) != -1) {
            model[i] = handdleNumberPointFix(model[i], baseWidth, defaultNumber(i))
          }
          if (i === "isActive" && model[i]) {
            model[i] = false
          }
        }
      } catch (e) {
        console.log("转换rem报错", e)
      }
    }
  }
}
function fixEvents(model, baseWidth) {
  //全部事件对象
  Object.keys(model).forEach(eventId => {
    // 具体事件对象
    const itemEvents = model[eventId].events
    Object.keys(itemEvents).forEach(eventType => {
      // 具体大事件分类对象
      const eventSubs = itemEvents[eventType]
      Object.keys(eventSubs).forEach(eventName => {
        //具体小事件的数组
        const events = eventSubs[eventName]
        events.forEach(event => {
          const { eventMovement, movementType, update } = event
          if (eventMovement === "component" && movementType === "options") {
            const { type, option } = update
            if (type === "diff") {
              option.forEach(itemOpt => {
                let { path, value } = itemOpt
                path = path.includes(".") ? path.split(".")[0] : path
                if (PXRESEVERPROP.indexOf(path) != -1) {
                  itemOpt.value = handdleNumberPointFix(value, baseWidth, defaultNumber(path))
                } else if (ARRAYPXRESEVERPROP.indexOf(path) !== -1) {
                  itemOpt.value = value.map(it => handdleNumberPointFix(it, baseWidth))
                }
              })
            } else {
              buildModel(option, baseWidth)
            }
          }
        })
      })
    })
  })
}

export function handdleNumberPointFix(data, baseWidth, defaultValue = 1) {
  // 已经转换过了，或者是百分比单位，直接返回
  // 考虑有字符串形式，如"100px"  主要是动画里的某些变量带了单位 此时不需要转换
  if (typeof data === "string" && (data.includes("rem") || data.includes("%") || data.includes("px") || data.includes("auto") || data.includes("自动") || data.includes("normal"))) {
    return data
  }
  let num = isInvalidNumber(data) ? defaultValue / baseWidth : parseFloat(data) / baseWidth
  // 数据已经出问题了，需要设置默认值
  if (isInvalidNumber(data)) {
    data = defaultValue
  }
  let len = num.toString().indexOf(".") !== -1 ? num.toString().split(".")[1].length : null
  return parseFloat(data) + "||" + ((len !== null && len > 5 ? num.toFixed(5) : num) + "rem")
}
// 无效的单位
export function isInvalidNumber(data) {
  return Number.isNaN(data) || data === null || data === undefined || `${data}`.trim() === ""
}
// 无效值替换为默认值
export function defaultNumber(type) {
  return ["width", "height", "left", "top"].includes(type) ? 10 : 1
}
